/* Neovatek : apparition douce des sections au défilement. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;
  var items = document.querySelectorAll('.neo-sec__inner');
  if (!items.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  items.forEach(function (el) {
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight) { el.classList.add('is-revealed', 'no-anim'); } else { io.observe(el); }
  });
  document.documentElement.classList.add('neo-reveal-on');
})();
